export default "__VITE_ASSET__D2hHbqG1__"